module.exports = __webpack_public_path__ + "img/infowing.756e103.png";